import { useEffect, FC } from 'react'
import { useNavigate } from 'react-router'
import { useAppDispatch, useAppSelector } from '../redux/store'
import { handleGoogleRedirect } from '../redux/auth/actions'
import {
  selectIsAuthenticated,
  selectAuthError,
  selectAuthLoading,
  selectUserRole,
} from '../redux/auth/selector'
import FullPageLoader from '../Components/Common/Loading/FullPageLoader'

const DEFAULT_REDIRECT_LINK = process.env.REACT_APP_REDIRECT_PATHNAME || '/'

const Redirect: FC = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const authError = useAppSelector(selectAuthError)
  const loading = useAppSelector(selectAuthLoading)
  const userRole = useAppSelector(selectUserRole)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const state = params.get('state')
    const scope = params.get('scope')
    const authuser = params.get('authuser')
    const hd = params.get('hd')
    const prompt = params.get('prompt')

    if (code && state) {
      dispatch(handleGoogleRedirect(code, state, scope || '', authuser || '', hd || '', prompt || ''))
    } else {
      navigate('/login', { replace: true })
    }
  }, [dispatch, navigate])

  useEffect(() => {
    if (isAuthenticated) {
      const storedPath = sessionStorage.getItem('redirectPath')
      const redirectPath =
        !storedPath || (userRole !== 'admin' && storedPath === '/support')
          ? DEFAULT_REDIRECT_LINK
          : storedPath
      navigate(redirectPath, { replace: true })
    }
  }, [isAuthenticated, navigate])

  useEffect(() => {
    if (authError) {
      navigate('/no-access', { replace: true, state: { error: authError } })
    }
  }, [authError, navigate])

  if (loading) {
    return <FullPageLoader message={'Authenticating...'} />
  }

  return null
}

export default Redirect
